import CesiumManagerWrapper from "./CesiumManagerWrapper";
import Abstract3DMapHandler from "./Abstract3DMapHandler";
import ConfirmationModal from "../../common/ConfirmationModal";
import PointsConverter from "./PointsConverter"

export default class SceneMap3DHandler extends Abstract3DMapHandler {

    constructor(first_appear_ad = 100, frequency_ad = 100) {
        super(first_appear_ad, frequency_ad);

        this.scene_id = null;
        this.owner_id = null;

        this.track_ids = [];
        this.loaded_ids = [];

        this.track_count = 0;

        this.scene_type = "other";
        // this.start_timer();
    }

    start_timer() {
        super.start_timer("replay_map");
    }

    async init(data) {
        this.tracks = data.tracks;
        this.points = data.points;
        this.owner_id = data.owner_id;
        this.scene_id = data.scene_id;
        this.track_ids = data.track_ids;
        this.colors = data.colors;
        this.activity_icon = data.activity_icon;
        this.time_zone = data.time_zone;
        this.scene_type = data.scene_type;
        this.path_length = data.path_length;
        this.contest_tasks = data.contest_tasks || {};
        this.host = data.host;
        const params = new URLSearchParams(window.location.search);
        const contestParam = params.get("contestTaskId");
        if (contestParam) {
            this.use_contest_task_id = contestParam;
        } else {
            this.use_contest_task_id = null; 
        }

        if (this.scene_id == null) {
            const userData = this.buildUserData();

            await CesiumManagerWrapper.initScene("map3D", {
                users: userData,
                checkContestType: "scene",
                hostInUse: this.host,
                pathsLength: this.path_length || 1230,
                sceneId: this.scene_id,
                staticLabels: []
            });
        } else {
            
            this.tracks = [];
            this.points = [];
            this.track_count = this.track_ids.length;
            
            if (!this.use_contest_task_id && this.contest_tasks.length > 0) {
                if (this.contest_tasks.length === 1) {
                    this.use_contest_task_id = this.contest_tasks[0].id;
                    await this.loadTracks();
                } else if (this.contest_tasks.length > 1) {
                    this.confirmationModal = new ConfirmationModal();
                    const message = {};
                
                    message["positive_btn"] = {
                        type: "danger",
                        label: I18n.t("website.user.contest_tasks.no_task"),
                        callback: () => {
                            this.use_contest_task_id = null;
                            $("#confirm_modal").modal("hide");
                            $("#confirm_modal").modal({ backdrop: 'static', keyboard: false });                            
                            this.loadTracks();
                        }
                    };
                    
                    let html = `
                    <div class="container">
                        <div class="row font-weight-bold py-2">
                        <div class="col fs-11">ID</div>
                        <div class="col fs-11">Name</div>
                        <div class="col fs-11">Start</div>
                        <div class="col fs-11">Updated</div>
                        </div>
                    `;
                    this.contest_tasks.forEach(task => {
                    html += `
                        <div class="row cursor-pointer contest-task-item py-1" data-task-id="${task.id}">
                        <div class="col fs-13">${task.id}</div>
                        <div class="col fs-13">${task.name}</div>
                        <div class="col fs-13">${task.start_time_begins || ''}</div>
                        <div class="col fs-13">${task.updated_at || ''}</div>
                        </div>
                    `;
                    });
                    html += `</div>`;
                    this.confirmationModal.displayConfirm(
                        I18n.t("website.user.contest_tasks.title"),
                        html,
                        message
                    );

                    $(document).on("click", ".contest-task-item", (e) => {
                        let selectedId = $(e.currentTarget).data("task-id");
                        this.use_contest_task_id = selectedId;

                        $("#confirm_modal").modal("hide");
                        $(document).off("click", ".contest-task-item");

                        this.loadTracks();
                    });
                } 
            } else {
                await this.loadTracks();
            }
        }        
    }

    async loadTracks() {
        $("#loading_scene_modal").modal({
            backdrop: 'static',
            keyboard: false
        });

        this.displayLoadingProgress();
        const loading = this.track_ids.map((x,i)=> this.getTrack(x,i));
        await Promise.all(loading);
       
        await this.getAround();
        await this.startCesium();
    }
    
    displayLoadingProgress() {
        $("#scene_loading_progress_text").html(I18n.t("website.scene.show.progress", { user_loaded: this.loaded_ids.length, total_users: this.track_count }));
        $("#scene_loading_progress").css("width", Math.round(((this.loaded_ids.length / this.track_count) * 100)) + "%");
    }   

    buildUserData() {
        return this.tracks.map((track, i) => ({
            userId: track.user.id,
            userName: track.user.user_name,
            track: {
                id: track.id,
                color: this.scene_id ? this.colors[i] : track.user.color,
                started_at: track.started_at,
                finished_at: track.finished_at,
                created_at: track.created_at,
                activity_icon: this.activity_icon,
                time_zone: this.time_zone,
                maxAltitude: track.max_altitude,
                ...(this.scene_id ? 
                    { raw_points_data: this.points[i] } : 
                    { points: this.points[i] }
                )
            }
        }));
    }

    async startCesium() {
        this.displayLoadingProgress();
        const userData = this.buildUserData();
        
        await CesiumManagerWrapper.initScene("map3D", {
            users: userData,
            sceneType: this.scene_type,
            hostInUse: this.host,
            pathsLength: this.path_length || 1230,
            sceneId: this.scene_id,
            windBearing: this.wind_bearing,
            staticLabels: this.localities_around,
            contestIdInUse: this.use_contest_task_id      
        });

        setTimeout(function () {
            $("#loading_scene_modal").modal("hide");
        }, 500)
    }

    getTrack(id,index) {
        return new Promise((resolve, reject) => {
            const ajaxData = {
                url: window.application.getAPIUrl() + "/v1/scene/" + this.scene_id + "/" + id,
                method: "GET",
                beforeSend: this.beforeSendHandler,
            };

            $.ajax(ajaxData).done((data) => {
                this.raw = data;

                const json = data.track == null ? decode(data) : data;

                this.tracks[index]= json.track;                
                // Store points data with flatter structure for better performance
                this.points[index] = {
                    points: json.points,
                    points_header: json.points_header,
                    wind_data: json.wind_data
                };
                this.loaded_ids.push(id);
                this.displayLoadingProgress();
                resolve();
            }).fail((err) => reject(err));
        });
    }   

    toUTF8Array(str) {
        let utf8 = [];
        for (let i = 0; i < str.length; i++) {
            let charcode = str.charCodeAt(i);
            if (charcode < 0x80) utf8.push(charcode);
            else if (charcode < 0x800) {
                utf8.push(0xc0 | (charcode >> 6),
                    0x80 | (charcode & 0x3f));
            }
            else if (charcode < 0xd800 || charcode >= 0xe000) {
                utf8.push(0xe0 | (charcode >> 12),
                    0x80 | ((charcode >> 6) & 0x3f),
                    0x80 | (charcode & 0x3f));
            }
            // surrogate pair
            else {
                i++;
                // UTF-16 encodes 0x10000-0x10FFFF by
                // subtracting 0x10000 and splitting the
                // 20 bits of 0x0-0xFFFFF into two halves
                charcode = 0x10000 + (((charcode & 0x3ff) << 10)
                    | (str.charCodeAt(i) & 0x3ff));
                utf8.push(0xf0 | (charcode >> 18),
                    0x80 | ((charcode >> 12) & 0x3f),
                    0x80 | ((charcode >> 6) & 0x3f),
                    0x80 | (charcode & 0x3f));
            }
        }
        return utf8;
    }
}